import { CastMember } from '@app/core/classes/cast-member';
import { createAction } from '@ngrx/store';

export const setCurrUser = createAction('[User] Set Current User', (user: CastMember) => ({ user }));
